var map = {
	"./add.svg": "./src/assets/images/add.svg",
	"./address.png": "./src/assets/images/address.png",
	"./anal/gyms-anal.png": "./src/assets/images/anal/gyms-anal.png",
	"./anal/revenue-anal.png": "./src/assets/images/anal/revenue-anal.png",
	"./anal/sessions-anal.png": "./src/assets/images/anal/sessions-anal.png",
	"./anal/users-anal.png": "./src/assets/images/anal/users-anal.png",
	"./app-bg-original.jpg": "./src/assets/images/app-bg-original.jpg",
	"./app-bg.jpg": "./src/assets/images/app-bg.jpg",
	"./app-bg.png": "./src/assets/images/app-bg.png",
	"./cancel.svg": "./src/assets/images/cancel.svg",
	"./clock.png": "./src/assets/images/clock.png",
	"./contact-white-blue.png": "./src/assets/images/contact-white-blue.png",
	"./crosshair-white-nobg.png": "./src/assets/images/crosshair-white-nobg.png",
	"./decrement-arrow.png": "./src/assets/images/decrement-arrow.png",
	"./distance.png": "./src/assets/images/distance.png",
	"./dob.png": "./src/assets/images/dob.png",
	"./dollar-white-blue.png": "./src/assets/images/dollar-white-blue.png",
	"./dynamicPricing/calendar_icon.png": "./src/assets/images/dynamicPricing/calendar_icon.png",
	"./dynamicPricing/control_icon.png": "./src/assets/images/dynamicPricing/control_icon.png",
	"./dynamicPricing/graph_inner.png": "./src/assets/images/dynamicPricing/graph_inner.png",
	"./dynamicPricing/graph_outer.png": "./src/assets/images/dynamicPricing/graph_outer.png",
	"./dynamicPricing/tiles_close_icon.png": "./src/assets/images/dynamicPricing/tiles_close_icon.png",
	"./dynamicPricing/timer_icon.png": "./src/assets/images/dynamicPricing/timer_icon.png",
	"./dynamicPricing/triangle_back.png": "./src/assets/images/dynamicPricing/triangle_back.png",
	"./dynamicPricing/triangle_down.png": "./src/assets/images/dynamicPricing/triangle_down.png",
	"./dynamicPricing/weight.png": "./src/assets/images/dynamicPricing/weight.png",
	"./email-icon.png": "./src/assets/images/email-icon.png",
	"./email.png": "./src/assets/images/email.png",
	"./emergency.png": "./src/assets/images/emergency.png",
	"./filter-blue-nobg.png": "./src/assets/images/filter-blue-nobg.png",
	"./filter-white-nobg.png": "./src/assets/images/filter-white-nobg.png",
	"./flexit-print-logo.png": "./src/assets/images/flexit-print-logo.png",
	"./gymhours-white-blue.png": "./src/assets/images/gymhours-white-blue.png",
	"./iconEdit.svg": "./src/assets/images/iconEdit.svg",
	"./increment-arrow.png": "./src/assets/images/increment-arrow.png",
	"./left-arrow-black.png": "./src/assets/images/left-arrow-black.png",
	"./left-arrow.png": "./src/assets/images/left-arrow.png",
	"./logo-dark.png": "./src/assets/images/logo-dark.png",
	"./logo-dark2.png": "./src/assets/images/logo-dark2.png",
	"./logo.png": "./src/assets/images/logo.png",
	"./logout-btn.png": "./src/assets/images/logout-btn.png",
	"./mail-bg-white-nobg.png": "./src/assets/images/mail-bg-white-nobg.png",
	"./phone.png": "./src/assets/images/phone.png",
	"./place-white-blue.png": "./src/assets/images/place-white-blue.png",
	"./price.png": "./src/assets/images/price.png",
	"./promotional_banner.png": "./src/assets/images/promotional_banner.png",
	"./qr-frame.min.png": "./src/assets/images/qr-frame.min.png",
	"./qr-frame.png": "./src/assets/images/qr-frame.png",
	"./right-arrow.png": "./src/assets/images/right-arrow.png",
	"./search-white-nobg.png": "./src/assets/images/search-white-nobg.png",
	"./selection_icon.png": "./src/assets/images/selection_icon.png",
	"./vpt/bookings-selected.svg": "./src/assets/images/vpt/bookings-selected.svg",
	"./vpt/bookings.svg": "./src/assets/images/vpt/bookings.svg",
	"./vpt/edit.svg": "./src/assets/images/vpt/edit.svg",
	"./vpt/overview-selected.svg": "./src/assets/images/vpt/overview-selected.svg",
	"./vpt/overview.svg": "./src/assets/images/vpt/overview.svg",
	"./vpt/trainers-selected.svg": "./src/assets/images/vpt/trainers-selected.svg",
	"./vpt/trainers.svg": "./src/assets/images/vpt/trainers.svg",
	"./waste-bin.png": "./src/assets/images/waste-bin.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";